export enum BuilderElementType {
  Accordion = 'Accordion',
  AccordionEdit = 'Accordion-edit',
  Button = 'Button',
  ButtonEdit = 'Button-edit',
  Countdown = 'Countdown',
  CountdownEdit = 'Countdown-edit',
  DescriptionList = 'DescriptionList',
  DescriptionListEdit = 'DescriptionList-edit',
  Divider = 'Divider',
  DividerEdit = 'Divider-edit',
  Footer = 'Footer',
  FooterEdit = 'Footer-edit',
  Gallery = 'Grid/Gallery',
  GalleryEdit = 'Grid/Gallery-edit',
  Header = 'Header',
  HeaderEdit = 'Header-edit',
  Headline = 'Headline',
  HeadlineEdit = 'Headline-edit',
  Icon = 'Icon',
  IconEdit = 'Icon-edit',
  Image = 'Image',
  ImageEdit = 'Image-edit',
  List = 'List',
  ListEdit = 'List-edit',
  Map = 'Map',
  MapEdit = 'Map-edit',
  Menu = 'Menu',
  MenuEdit = 'Menu-edit',
  Newsletter = 'Newsletter',
  Panel = 'Panel',
  PanelEdit = 'Panel-edit',
  NewsletterEdit = 'Newsletter-edit',
  Row = 'Row',
  RowEdit = 'Row-edit',
  Page = 'Page',
  Popover = 'Popover',
  PopoverEdit = 'Popover-edit',
  Section = 'Section',
  SectionEdit = 'Section-edit',
  Slider = 'Slider',
  SliderEdit = 'Slider-edit',
  Slideshow = 'Slideshow',
  SlideshowEdit = 'Slideshow-edit',
  Social = 'Social',
  SocialEdit = 'Social-edit',
  Table = 'Table',
  TableEdit = 'Table-edit',
  Tabs = 'Tabs',
  TabsEdit = 'Tabs-edit',
  Text = 'Text',
  TextEdit = 'Text-edit',
  ToTop = 'To top',
  ToTopEdit = 'To top-edit',
  Video = 'Video',
  VideoEdit = 'Video-edit',
}
